'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.NarrowSection = undefined;

var _templateObject = _taggedTemplateLiteral(['\n  & ', ' {\n    width: 100%;\n    @media ', ' {\n      width: 70%;\n    }\n    @media ', ' {\n      width: 50%;\n    }\n  }\n'], ['\n  & ', ' {\n    width: 100%;\n    @media ', ' {\n      width: 70%;\n    }\n    @media ', ' {\n      width: 50%;\n    }\n  }\n']);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _Section = require('./Section');

var _SectionContent = require('./SectionContent');

var _styles = require('./styles');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
/*:: import * as React from 'react' */
/*:: import type {ComponentType} from 'react' */
/*:: import type {SectionProps} from './Section' */


var NarrowSection /*: ComponentType<SectionProps> */ = exports.NarrowSection = (0, _styledComponents2.default)(_Section.Section)(_templateObject, _SectionContent.SectionContent, _styles.styles.media.tablet, _styles.styles.media.laptop);
NarrowSection.displayName = 'NarrowSection';


//////////////////
// WEBPACK FOOTER
// ../tutellus-ui/lib/NarrowSection.js
// module id = 641
// module chunks = 0